import React from 'react'
import classnames from 'classnames'
import Banner from './Banner'

const Page = ({ children, page, noPadding }) => (
  <div id="Page">
    {(page.headerImage || page.headerText) && <Banner page={page} />}
    <div
      className={classnames('page-container', {
        'p-0': noPadding,
        'is-auth': _.includes(page.url, 'auth'),
      })}
    >
      {children}
    </div>
  </div>
)

export default Page
